
import { Payload } from "./interfaces";
import {GET_ORDERS,CHANGE_ORDER_STATUS} from './constants'



export function getOrdersAction(payload: Payload) {
    return {
      type: GET_ORDERS,
      payload,
    };
  }
export function changeOrdersStatusAction(payload: Payload) {
    return {
      type: CHANGE_ORDER_STATUS,
      payload,
    };
  }